export const SURVEY_QUIZ = 0;
export const SURVEY_POLL = 1;
